// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Manrope:wght@400;500;600;700&family=JetBrains+Mono:wght@500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= SCÈNE ================= */

.login-screen {
    position: relative;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
    background: linear-gradient(160deg,
            var(--color-bg-deep) 0%,
            var(--color-bg-mid) 55%,
            var(--color-bg-high) 100%);
    font-family: var(--font-body);
}

/* ================= GRILLE DE SIGNAUX (fond) ================= */

.login-nodes {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
    grid-auto-rows: 56px;
    place-items: center;
    opacity: 0.55;
    mask-image: radial-gradient(circle at 20% 30%,
            black 0%,
            rgba(0, 0, 0, 0.5) 45%,
            transparent 80%);
    pointer-events: none;
}

.login-node {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--brand-live);
    box-shadow: 0 0 0 0 rgba(22, 199, 154, 0.6);
    animation: login-node-pulse 3.4s ease-in-out infinite;
}

.login-node--alert {
    background: var(--brand-accent-warm);
    box-shadow: 0 0 0 0 rgba(255, 159, 28, 0.6);
    animation-name: login-node-pulse-alert;
}

.login-node:nth-child(3n) {
    animation-delay: 0.4s;
}

.login-node:nth-child(4n) {
    animation-delay: 1.1s;
}

.login-node:nth-child(5n) {
    animation-delay: 1.8s;
}

.login-node:nth-child(7n) {
    animation-delay: 2.3s;
}

@keyframes login-node-pulse {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(22, 199, 154, 0.55);
        opacity: 0.5;
    }

    50% {
        box-shadow: 0 0 0 6px rgba(22, 199, 154, 0);
        opacity: 1;
    }
}

@keyframes login-node-pulse-alert {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(255, 159, 28, 0.55);
        opacity: 0.5;
    }

    50% {
        box-shadow: 0 0 0 6px rgba(255, 159, 28, 0);
        opacity: 1;
    }
}

.login-nodes-sweep {
    position: absolute;
    inset: -20%;
    background: conic-gradient(from 0deg,
            transparent 0deg,
            rgba(47, 111, 235, 0.16) 18deg,
            transparent 40deg,
            transparent 360deg);
    animation: login-sweep-rotate 9s linear infinite;
    mix-blend-mode: screen;
}

@keyframes login-sweep-rotate {
    to {
        transform: rotate(360deg);
    }
}

@media (prefers-reduced-motion: reduce) {

    .login-node,
    .login-node--alert,
    .login-nodes-sweep {
        animation: none;
    }
}

@media (max-width: 767.98px) {
    .login-nodes {
        opacity: 0.3;
    }
}

/* ================= SCÈNE / GRILLE PRINCIPALE ================= */

.login-stage {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: clamp(2rem, 6vw, 6rem);
    padding: 2.5rem 1.5rem;
    max-width: 1240px;
    margin: 0 auto;
}

@media (max-width: 991.98px) {
    .login-stage {
        flex-direction: column;
        justify-content: flex-start;
        padding-top: 3rem;
    }
}

/* ================= PITCH PRODUIT (gauche) ================= */

.login-pitch {
    flex: 1 1 480px;
    max-width: 520px;
    color: var(--color-text-invert);
}

@media (max-width: 991.98px) {
    .login-pitch {
        display: none;
    }
}

.login-brand {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    margin-bottom: 3rem;
}

.login-brand-logo {
    height: 32px;
    width: auto;
}

.login-brand-name {
    font-family: var(--font-display);
    font-weight: 700;
    font-size: 1.25rem;
    letter-spacing: 0.01em;
    color: #fff;
}

.login-eyebrow {
    display: inline-block;
    font-family: var(--font-mono);
    font-size: 0.72rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--brand-live);
    margin-bottom: 0.9rem;
}

.login-headline {
    font-family: var(--font-display);
    font-weight: 600;
    font-size: clamp(2rem, 3.4vw, 2.75rem);
    line-height: 1.15;
    color: #fff;
    margin: 0 0 1.1rem;
}

.login-subtext {
    font-size: 0.98rem;
    line-height: 1.6;
    color: var(--color-text-invert-soft);
    max-width: 40ch;
    margin: 0 0 2.5rem;
}

.login-status {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-family: var(--font-mono);
    font-size: 0.72rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-text-invert-soft);
    border: 1px solid var(--color-line-onhome);
    border-radius: 999px;
    padding: 0.4rem 0.85rem;
}

.login-status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--brand-live);
    box-shadow: 0 0 0 0 rgba(22, 199, 154, 0.6);
    animation: login-node-pulse 2s ease-in-out infinite;
}

/* ================= CARTE DE CONNEXION ================= */

.login-card {
    flex: 0 1 400px;
    width: 100%;
    max-width: 400px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-top: 2px solid var(--bs-primary);
    border-radius: var(--bs-border-radius-lg);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    padding: 2.25rem 2rem;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
    animation: login-card-in 0.5s ease both;
}

@keyframes login-card-in {
    from {
        opacity: 0;
        transform: translateY(14px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .login-card {
        animation: none;
    }
}

.login-card-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1.75rem;
}

.login-title {
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 1.5rem;
    color: #fff;
    margin: 0 0 0.35rem;
}

.login-lead {
    font-size: 0.85rem;
    color: var(--color-text-invert-soft);
    margin: 0 0 1.75rem;
}

.login-field {
    margin-bottom: 1.15rem;
}

.login-field label {
    display: block;
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--color-text-invert-soft);
    margin-bottom: 0.4rem;
}

.login-field input {
    width: 100%;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--color-line-onhome);
    border-radius: var(--bs-border-radius);
    color: var(--color-text-invert);
    font-family: var(--font-body);
    font-size: 0.92rem;
    padding: 0.68rem 0.85rem;
    transition: border-color 0.15s ease, background-color 0.15s ease,
        box-shadow 0.15s ease;
}

.login-field input::placeholder {
    color: rgba(151, 166, 187, 0.55);
}

.login-field input:hover {
    border-color: rgba(255, 255, 255, 0.18);
}

.login-field input:focus,
.login-field input:focus-visible {
    outline: none;
    border-color: var(--bs-primary);
    background: rgba(255, 255, 255, 0.06);
    box-shadow: 0 0 0 3px rgba(47, 111, 235, 0.25);
}

.login-input-wrap {
    position: relative;
}

.login-input-wrap input {
    padding-right: 2.6rem;
}

.login-eye {
    position: absolute;
    right: 0.6rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--color-text-invert-soft);
    display: flex;
    align-items: center;
    padding: 0.25rem;
    cursor: pointer;
    border-radius: 6px;
}

.login-eye:hover {
    color: #fff;
}

.login-eye:focus-visible {
    outline: 2px solid var(--bs-primary);
    outline-offset: 2px;
}

.login-alert {
    font-size: 0.85rem;
    border-left: 3px solid var(--bs-danger, #dc3545);
    background: rgba(220, 53, 69, 0.1);
    color: #ffb3b8;
    border-radius: 0 6px 6px 0;
    padding: 0.65rem 0.85rem;
    margin-bottom: 1.15rem;
}

.login-alert--success {
    border-left-color: var(--bs-success, #198754);
    background: rgba(25, 135, 84, 0.12);
    color: #8ee6b3;
}

.login-alert--warning {
    border-left-color: var(--brand-accent-warm);
    background: rgba(255, 159, 28, 0.12);
    color: #ffcf8a;
}

.login-alert--info {
    border-left-color: var(--bs-primary);
    background: rgba(47, 111, 235, 0.12);
    color: #a9c4fb;
}

.login-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
}

.login-remember {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    font-size: 0.82rem;
    color: var(--color-text-invert-soft);
    cursor: pointer;
}

.login-remember input {
    accent-color: var(--bs-primary);
}

.login-forgot {
    font-size: 0.82rem;
    color: var(--bs-primary);
    text-decoration: none !important;
}

.login-forgot:hover {
    color: var(--bs-link-hover-color);
}

.login-submit {
    width: 100%;
    border: none;
    border-radius: var(--bs-border-radius);
    padding: 0.75rem 1rem;
    font-family: var(--font-body);
    font-weight: 700;
    font-size: 0.95rem;
    color: #fff;
    background: linear-gradient(135deg, var(--bs-primary), #4f8cff);
    box-shadow: 0 10px 24px rgba(47, 111, 235, 0.35);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.login-submit:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 14px 30px rgba(47, 111, 235, 0.45);
}

.login-submit:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 3px;
}

.login-submit:disabled {
    opacity: 0.75;
    cursor: not-allowed;
    transform: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/login.css"],"names":[],"mappings":"AAEA,8CAA8C;;AAE9C;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB;;;sCAGkC;IAClC,6BAA6B;AACjC;;AAEA,iEAAiE;;AAEjE;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,2DAA2D;IAC3D,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb;;;4BAGwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,2CAA2C;IAC3C,qDAAqD;AACzD;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI;;QAEI,4CAA4C;QAC5C,YAAY;IAChB;;IAEA;QACI,2CAA2C;QAC3C,UAAU;IACd;AACJ;;AAEA;;IAEI;;QAEI,4CAA4C;QAC5C,YAAY;IAChB;;IAEA;QACI,2CAA2C;QAC3C,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;;;+BAI2B;IAC3B,gDAAgD;IAChD,sBAAsB;AAC1B;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;IAEI;;;QAGI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,kEAAkE;;AAElE;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,iBAAiB;IACrB;AACJ;;AAEA,+DAA+D;;AAE/D;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sCAAsC;IACtC,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,2CAA2C;IAC3C,mDAAmD;AACvD;;AAEA,2DAA2D;;AAE3D;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,qCAAqC;IACrC,uCAAuC;IACvC,yCAAyC;IACzC,2BAA2B;IAC3B,mCAAmC;IACnC,qBAAqB;IACrB,2CAA2C;IAC3C,uCAAuC;AAC3C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,0CAA0C;IAC1C,sCAAsC;IACtC,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;IAClB,wBAAwB;IACxB;6BACyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,aAAa;IACb,+BAA+B;IAC/B,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,kCAAkC;IAClC,cAAc;IACd,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;IAC7C,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,+DAA+D;IAC/D,gDAAgD;IAChD,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Manrope:wght@400;500;600;700&family=JetBrains+Mono:wght@500&display=swap\");\n\n/* ================= SCÈNE ================= */\n\n.login-screen {\n    position: relative;\n    min-height: 100vh;\n    width: 100%;\n    overflow: hidden;\n    background: linear-gradient(160deg,\n            var(--color-bg-deep) 0%,\n            var(--color-bg-mid) 55%,\n            var(--color-bg-high) 100%);\n    font-family: var(--font-body);\n}\n\n/* ================= GRILLE DE SIGNAUX (fond) ================= */\n\n.login-nodes {\n    position: absolute;\n    inset: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));\n    grid-auto-rows: 56px;\n    place-items: center;\n    opacity: 0.55;\n    mask-image: radial-gradient(circle at 20% 30%,\n            black 0%,\n            rgba(0, 0, 0, 0.5) 45%,\n            transparent 80%);\n    pointer-events: none;\n}\n\n.login-node {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: var(--brand-live);\n    box-shadow: 0 0 0 0 rgba(22, 199, 154, 0.6);\n    animation: login-node-pulse 3.4s ease-in-out infinite;\n}\n\n.login-node--alert {\n    background: var(--brand-accent-warm);\n    box-shadow: 0 0 0 0 rgba(255, 159, 28, 0.6);\n    animation-name: login-node-pulse-alert;\n}\n\n.login-node:nth-child(3n) {\n    animation-delay: 0.4s;\n}\n\n.login-node:nth-child(4n) {\n    animation-delay: 1.1s;\n}\n\n.login-node:nth-child(5n) {\n    animation-delay: 1.8s;\n}\n\n.login-node:nth-child(7n) {\n    animation-delay: 2.3s;\n}\n\n@keyframes login-node-pulse {\n\n    0%,\n    100% {\n        box-shadow: 0 0 0 0 rgba(22, 199, 154, 0.55);\n        opacity: 0.5;\n    }\n\n    50% {\n        box-shadow: 0 0 0 6px rgba(22, 199, 154, 0);\n        opacity: 1;\n    }\n}\n\n@keyframes login-node-pulse-alert {\n\n    0%,\n    100% {\n        box-shadow: 0 0 0 0 rgba(255, 159, 28, 0.55);\n        opacity: 0.5;\n    }\n\n    50% {\n        box-shadow: 0 0 0 6px rgba(255, 159, 28, 0);\n        opacity: 1;\n    }\n}\n\n.login-nodes-sweep {\n    position: absolute;\n    inset: -20%;\n    background: conic-gradient(from 0deg,\n            transparent 0deg,\n            rgba(47, 111, 235, 0.16) 18deg,\n            transparent 40deg,\n            transparent 360deg);\n    animation: login-sweep-rotate 9s linear infinite;\n    mix-blend-mode: screen;\n}\n\n@keyframes login-sweep-rotate {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    .login-node,\n    .login-node--alert,\n    .login-nodes-sweep {\n        animation: none;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .login-nodes {\n        opacity: 0.3;\n    }\n}\n\n/* ================= SCÈNE / GRILLE PRINCIPALE ================= */\n\n.login-stage {\n    position: relative;\n    z-index: 1;\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: clamp(2rem, 6vw, 6rem);\n    padding: 2.5rem 1.5rem;\n    max-width: 1240px;\n    margin: 0 auto;\n}\n\n@media (max-width: 991.98px) {\n    .login-stage {\n        flex-direction: column;\n        justify-content: flex-start;\n        padding-top: 3rem;\n    }\n}\n\n/* ================= PITCH PRODUIT (gauche) ================= */\n\n.login-pitch {\n    flex: 1 1 480px;\n    max-width: 520px;\n    color: var(--color-text-invert);\n}\n\n@media (max-width: 991.98px) {\n    .login-pitch {\n        display: none;\n    }\n}\n\n.login-brand {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    margin-bottom: 3rem;\n}\n\n.login-brand-logo {\n    height: 32px;\n    width: auto;\n}\n\n.login-brand-name {\n    font-family: var(--font-display);\n    font-weight: 700;\n    font-size: 1.25rem;\n    letter-spacing: 0.01em;\n    color: #fff;\n}\n\n.login-eyebrow {\n    display: inline-block;\n    font-family: var(--font-mono);\n    font-size: 0.72rem;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: var(--brand-live);\n    margin-bottom: 0.9rem;\n}\n\n.login-headline {\n    font-family: var(--font-display);\n    font-weight: 600;\n    font-size: clamp(2rem, 3.4vw, 2.75rem);\n    line-height: 1.15;\n    color: #fff;\n    margin: 0 0 1.1rem;\n}\n\n.login-subtext {\n    font-size: 0.98rem;\n    line-height: 1.6;\n    color: var(--color-text-invert-soft);\n    max-width: 40ch;\n    margin: 0 0 2.5rem;\n}\n\n.login-status {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-family: var(--font-mono);\n    font-size: 0.72rem;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--color-text-invert-soft);\n    border: 1px solid var(--color-line-onhome);\n    border-radius: 999px;\n    padding: 0.4rem 0.85rem;\n}\n\n.login-status-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: var(--brand-live);\n    box-shadow: 0 0 0 0 rgba(22, 199, 154, 0.6);\n    animation: login-node-pulse 2s ease-in-out infinite;\n}\n\n/* ================= CARTE DE CONNEXION ================= */\n\n.login-card {\n    flex: 0 1 400px;\n    width: 100%;\n    max-width: 400px;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-top: 2px solid var(--bs-primary);\n    border-radius: var(--bs-border-radius-lg);\n    backdrop-filter: blur(18px);\n    -webkit-backdrop-filter: blur(18px);\n    padding: 2.25rem 2rem;\n    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);\n    animation: login-card-in 0.5s ease both;\n}\n\n@keyframes login-card-in {\n    from {\n        opacity: 0;\n        transform: translateY(14px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .login-card {\n        animation: none;\n    }\n}\n\n.login-card-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 1.75rem;\n}\n\n.login-title {\n    font-family: var(--font-display);\n    font-weight: 600;\n    font-size: 1.5rem;\n    color: #fff;\n    margin: 0 0 0.35rem;\n}\n\n.login-lead {\n    font-size: 0.85rem;\n    color: var(--color-text-invert-soft);\n    margin: 0 0 1.75rem;\n}\n\n.login-field {\n    margin-bottom: 1.15rem;\n}\n\n.login-field label {\n    display: block;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--color-text-invert-soft);\n    margin-bottom: 0.4rem;\n}\n\n.login-field input {\n    width: 100%;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid var(--color-line-onhome);\n    border-radius: var(--bs-border-radius);\n    color: var(--color-text-invert);\n    font-family: var(--font-body);\n    font-size: 0.92rem;\n    padding: 0.68rem 0.85rem;\n    transition: border-color 0.15s ease, background-color 0.15s ease,\n        box-shadow 0.15s ease;\n}\n\n.login-field input::placeholder {\n    color: rgba(151, 166, 187, 0.55);\n}\n\n.login-field input:hover {\n    border-color: rgba(255, 255, 255, 0.18);\n}\n\n.login-field input:focus,\n.login-field input:focus-visible {\n    outline: none;\n    border-color: var(--bs-primary);\n    background: rgba(255, 255, 255, 0.06);\n    box-shadow: 0 0 0 3px rgba(47, 111, 235, 0.25);\n}\n\n.login-input-wrap {\n    position: relative;\n}\n\n.login-input-wrap input {\n    padding-right: 2.6rem;\n}\n\n.login-eye {\n    position: absolute;\n    right: 0.6rem;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: var(--color-text-invert-soft);\n    display: flex;\n    align-items: center;\n    padding: 0.25rem;\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.login-eye:hover {\n    color: #fff;\n}\n\n.login-eye:focus-visible {\n    outline: 2px solid var(--bs-primary);\n    outline-offset: 2px;\n}\n\n.login-alert {\n    font-size: 0.85rem;\n    border-left: 3px solid var(--bs-danger, #dc3545);\n    background: rgba(220, 53, 69, 0.1);\n    color: #ffb3b8;\n    border-radius: 0 6px 6px 0;\n    padding: 0.65rem 0.85rem;\n    margin-bottom: 1.15rem;\n}\n\n.login-alert--success {\n    border-left-color: var(--bs-success, #198754);\n    background: rgba(25, 135, 84, 0.12);\n    color: #8ee6b3;\n}\n\n.login-alert--warning {\n    border-left-color: var(--brand-accent-warm);\n    background: rgba(255, 159, 28, 0.12);\n    color: #ffcf8a;\n}\n\n.login-alert--info {\n    border-left-color: var(--bs-primary);\n    background: rgba(47, 111, 235, 0.12);\n    color: #a9c4fb;\n}\n\n.login-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n    flex-wrap: wrap;\n}\n\n.login-remember {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    font-size: 0.82rem;\n    color: var(--color-text-invert-soft);\n    cursor: pointer;\n}\n\n.login-remember input {\n    accent-color: var(--bs-primary);\n}\n\n.login-forgot {\n    font-size: 0.82rem;\n    color: var(--bs-primary);\n    text-decoration: none !important;\n}\n\n.login-forgot:hover {\n    color: var(--bs-link-hover-color);\n}\n\n.login-submit {\n    width: 100%;\n    border: none;\n    border-radius: var(--bs-border-radius);\n    padding: 0.75rem 1rem;\n    font-family: var(--font-body);\n    font-weight: 700;\n    font-size: 0.95rem;\n    color: #fff;\n    background: linear-gradient(135deg, var(--bs-primary), #4f8cff);\n    box-shadow: 0 10px 24px rgba(47, 111, 235, 0.35);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.login-submit:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 14px 30px rgba(47, 111, 235, 0.45);\n}\n\n.login-submit:focus-visible {\n    outline: 2px solid #fff;\n    outline-offset: 3px;\n}\n\n.login-submit:disabled {\n    opacity: 0.75;\n    cursor: not-allowed;\n    transform: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
